<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3hqLZZ/images/cover.jpg?1703000821117" alt="This image is the cover for the book Cassel and Hazebrouck 1940, Battleground Dunkirk"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cassel and Hazebrouck 1940, Battleground Dunkirk
      </h1>
      <p class="bookDescription body article font2">
        <p>This is the first detailed account of the rearguard action that took place between 25 and 29 May 1940 at Cassel and Hazebrouck on the western perimeter of the Dunkirk Corridor. By 25 May the decision to evacuate the BEF via Dunkirk had already been taken, Lord Gort, commanding the BEF in France, had given instructions to Lieutenant General Sir Ronald Adam to relinquish his command of III Corps and prepare a perimeter of defense around Dunkirk. As part of the western defensive line of the Dunkirk Corridor, 145 Brigade were deployed to Cassel and Hazebrouck with the instructions to hold the two towns until the last man. Under the command of Brigadier Nigel Somerset, the brigade occupied Hazebrouck with the infantry of 1st Buckinghamshire Battalion and Cassel with the 4/Ox and Bucks Light infantry together with the regulars of the 2nd Battalion Gloucestershire Regiment. Attached to Somersets meager force was a number of units that had previously been part of two of Gorts ad hoc formations—Macforce and Woodforce, and it was with these men that the two towns were fortified against the advancing German armored divisions.While Hazebrouck was overwhelmed very quickly, the hilltop town of Cassel held out for much longer with German forces failing to consolidate any penetration of the perimeter. The book looks closely at the deployment of units in both towns and focuses on the individuals involved in the defense and the subsequent breakout, which ended in capture or death for so many. There are two car tours that explore the surrounding area of Cassel and the deployment of platoons within Hazebrouck. These are supplemented by two walking tours, one in Cassel itself and the second further to the west of the town around the area controlled by B and D Companies of the 2nd Gloucesters. The book is illustrated with ten maps and over 100 modern and contemporary photographs.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jerry Murland
      </h2>
      
      <p class="authorDescription body article">Jerry Murland followed a successful career as a teacher, and since retirement has devoted his time to researching and writing on the two world wars. His books include Retreat and Rearguard 1914, Battle on the Aisne 1914, Aristocrats Go to War, Retreat and Rearguard: Somme 1918 and Retreat and Rearguard: Dunkirk 1940. He has also written two Battle Ground Europe publications and is co-author of the Battle Lines guidebook series to the Western Front 191418.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4f823996